import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import HeaderWithSidebar from '../HeaderWithSidebar';
import PageHeader from '../../organisms/common/PageHeader';

const HeaderSidebar1Col = ({ children, title, icon }) => (
  <HeaderWithSidebar>
    {title && <PageHeader title={title} icon={icon} />}

    <Grid container>
      <Grid item lg={12} md={12} sm={12}>
        {children}
      </Grid>
    </Grid>
  </HeaderWithSidebar>
);


HeaderSidebar1Col.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string,
  icon: PropTypes.node,
};

HeaderSidebar1Col.defaultProps = {
  title: null,
  icon: undefined,
};

export default HeaderSidebar1Col;
